module.exports = __webpack_public_path__ + "img/tab-content-03.6fa15763.jpg";